<template>
  <game-template title="Lisez attentivement l'infographie">
    <template v-slot:content>
      <div class="infography-wrapper">
        <div v-if="!$browserDetect.isIE" v-html="require('../assets/infography.svg?inline')" class="infography"></div>
        <div v-else class="ie-image-wrapper">
          <img src="../assets/infography.jpg">
        </div>
        <div class="infography-button-wrapper">
          <p class="title">Vous êtes prêt pour tester vos connaissances ?</p>
          <button class="button" @click="next">Passer le test</button>
        </div>
      </div>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Infography',
  mixins: [stepMixin]
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,900;1,400&display=swap');

.infography-wrapper {
  position: relative;
  .ie-image-wrapper {
    padding-bottom: 80px;
    img {
      max-width: 100%;
    }
  }
  .infography-button-wrapper {
    height: 150px;
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    background-color: $primary-color;
    color: #fff;
    width: 980px;
    margin: 0 auto;
    border-radius: $radius;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .title {
      font-weight: 700;
      font-size: 1.6rem;
      margin-bottom: 20px;
    }
  }
}
</style>
